// Login logo
export const loginLogo = require("./login-logo.svg");
